import { render, staticRenderFns } from "./PostFormHeader.vue?vue&type=template&id=7ab0662e"
import script from "./PostFormHeader.vue?vue&type=script&lang=ts"
export * from "./PostFormHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports